export default "__VITE_ASSET__C9Dz85OI__"